/**
 * Compact row/header action classes for Outlook surfaces.
 * Fixed height, 1px border, no Framer lift — usable on <button> or <a>.
 * Wire Reply / Outlook web / Sync / Refresh in later polish areas.
 */

export const compactActionBase =
  'inline-flex h-9 items-center justify-center gap-1.5 rounded-lg border px-3 text-xs font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-primary-500/20 disabled:cursor-not-allowed disabled:opacity-50';

/** Primary chrome (Refresh, secondary row actions). */
export const compactActionPrimary = `${compactActionBase} border-primary-500/15 text-primary-600 hover:bg-primary-50`;

/** Accent chrome (Sync Outlook, Outlook web link). */
export const compactActionAccent = `${compactActionBase} border-accent-500/30 text-accent-700 hover:bg-accent-50`;

/** Emphasized secondary (Reply / Reply all). */
export const compactActionSecondary = `${compactActionBase} border-primary-500/30 text-primary-700 hover:bg-primary-50`;

/** Icon-only square control (view, close, Reply, Refresh). */
export const compactActionIcon =
  'inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-lg border border-primary-500/15 text-primary-600 hover:bg-primary-50 focus:outline-none focus:ring-2 focus:ring-primary-500/20 disabled:cursor-not-allowed disabled:opacity-50';

/** Icon-only accent (Outlook web, Sync Outlook). */
export const compactActionIconAccent =
  'inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-lg border border-accent-500/30 text-accent-700 hover:bg-accent-50 focus:outline-none focus:ring-2 focus:ring-primary-500/20 disabled:cursor-not-allowed disabled:opacity-50';

/** Icon-only emphasized (Reply / Reply all). */
export const compactActionIconSecondary =
  'inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-lg border border-primary-500/30 text-primary-700 hover:bg-primary-50 focus:outline-none focus:ring-2 focus:ring-primary-500/20 disabled:cursor-not-allowed disabled:opacity-50';

/** Muted / unavailable affordance (no web link). */
export const compactActionMuted =
  'inline-flex h-9 items-center justify-center gap-1.5 rounded-lg border border-primary-500/15 px-3 text-xs text-primary-500/40';

/** Icon-only muted / unavailable. */
export const compactActionIconMuted =
  'inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-lg border border-primary-500/15 text-primary-500/40';

